// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page--shop-sparkling-water .page{padding-bottom:0}.product-landing__hero--media img{max-height:400px;-o-object-fit:contain;object-fit:contain}.page--shop-sparkling-water__outro-image{max-height:400px}@media (min-width:1460px){.product-landing__hero--media img{max-height:600px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
